import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import Subfee from '../subfee/Model.Subfee';

export default class MediaFileSubfee
  extends Model<Model.IMediaFileSubfee>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IMediaFileSubfee>
{
  id: number;
  subfeeId: number;
  subfee: Subfee;
  mediaFileId: number;
  mediaFile: MediaFile;
  languageIsoCode?: Locale.Languages;

  constructor(
    data: Partial<Model.IMediaFileSubfee> | Utils.FormData<Model.IMediaFileSubfee>,
    language?: Locale.Languages
  ) {
    super({ mediaFile: MediaFile, subfee: Subfee }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
